module.exports = __webpack_public_path__ + "static/media/Union.0613190a.png";